import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformKeysToSnakeCase, transformV2ClientResponse } from 'helpers/core';

import URLS from 'constants/urls';

const methods = {
  create: (http, venueId, waiverData) =>
    http
      .post(URLS.venue.createWaiver(venueId), transformKeysToSnakeCase(waiverData))
      .then(() => methods.latest(http, venueId)),
  toggle: (http, venueId, waiverId, isEnabled) =>
    http
      .patch(URLS.venue.updateWaiver(venueId, waiverId), transformKeysToSnakeCase({ isEnabled }))
      .then(() => methods.latest(http, venueId)),
  latest: (http, venueId) =>
    http
      .get(URLS.venue.waiver(venueId))
      .then(transformV2ClientResponse)
      .catch(() => null),
  version: (http, venueId, waiverId, waiverVersionId) =>
    http.get(URLS.venue.waiverVersion(venueId, waiverId, waiverVersionId)).then(transformV2ClientResponse),
};

const handler = ({ httpClient: http }, method, ...args) => methods[method](http, ...args);

export default makeEntityScaffold('VENUE_PAGE_WAIVERS', handler, {
  defaultKey: (nil, method, venueId, waiverId, waiverVersionId) =>
    (method === 'version' ? ['version', venueId, waiverId, waiverVersionId] : ['latest', venueId]).join('-'),
  method: Object.fromEntries(Object.keys(methods).map(k => [k, k])),
});
